import { getMenuStore } from './store.js';
import { assemblePrintData } from './transform.js';
import { todayIso } from './util.js';
import type { PrintData } from './transform.js';

// Re-export the print-payload types so existing importers (Printer.tsx,
// templates.tsx) keep importing them from './printData.js'.
export type {
  PrintItem,
  PrintSection,
  PrintCourseIndex,
  PrintMenu,
  PrintDailyDay,
  PrintData,
} from './transform.js';

/** Build the full print payload (the WP MENU_DATA shape) — fetch via the store,
 *  then assemble with the pure builder. */
export async function buildPrintData(): Promise<PrintData> {
  const store = getMenuStore();
  const today = todayIso();
  const dishes = await store.listDishes();
  const history = await store.listHistory(365);
  const futureServings = await store.listFutureServings(today);
  return assemblePrintData(dishes, history, futureServings, today);
}
